// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"726":"8235b523","787":"e57d2f9d"}[chunkId] + ".chunk.js";
};